import Snap from "snapsvg";
import $ from "jquery";

const clock = {
  STOPPED_CLASS: "--stopped",
  ANIMATION_TIME: 500,
  hours: null,
  minutes: null,

  /**
   * Get angle to set for minute/second hand.
   *
   * @param  {number} minutesOrSeconds
   * @return {number}
   */
  getMinuteSecondHandAngle(minutesOrSeconds) {
    return (360 / 60) * minutesOrSeconds;
  },

  /**
   * Get angle to set for hour hand.
   *
   * @param  {number} hours
   * @return {number}
   */
  getHourHandAngle(hours) {
    if (hours >= 12) {
      hours -= 12;
    }
    return (360 / 12) * hours;
  },

  /**
   * Updating time.
   */
  updateTime() {
    const time = new Date();
    const seconds = time.getSeconds();
    const minutes = time.getMinutes();
    const hours = time.getHours();

    const secondsMatrix = new Snap.Matrix();
    secondsMatrix.rotate(
      this.getMinuteSecondHandAngle(seconds),
      this.cx,
      this.cy
    );
    this.secondHand.animate(
      {
        transform: secondsMatrix,
      },
      this.ANIMATION_TIME,
      mina.elastic
    );

    // only update minutes/hours if they've changed.
    if (this.minutes !== minutes) {
      const minutesMatrix = new Snap.Matrix();
      minutesMatrix.rotate(
        this.getMinuteSecondHandAngle(minutes),
        this.cx + this.adjustCenters,
        this.cy
      );
      this.minuteHand.animate(
        {
          transform: minutesMatrix,
        },
        this.ANIMATION_TIME,
        mina.elastic
      );
      this.minutes = minutes;
    }

    if (this.hours !== hours) {
      const hoursMatrix = new Snap.Matrix();
      hoursMatrix.rotate(
        this.getHourHandAngle(hours),
        this.cx + this.adjustCenters,
        this.cy
      );
      this.hourHand.animate(
        {
          transform: hoursMatrix,
        },
        this.ANIMATION_TIME,
        mina.elastic
      );
      this.hours = hours;
    }
  },

  /**
   * Draw a new clock.
   */
  drawClock() {
    this.clock = Snap(".svg-clock");
    this.clock.attr({
      viewBox: `0 0 ${this.cx * 2} ${this.cy * 2}`,
    });

    // cx,cy,r
    this.clock.circle(this.cx, this.cy, this.r).attr({
      fill: "#EEE",
      stroke: "#71A097",
      "stroke-width": "3px",
    });

    // x,y,width,height [rx]. [ry]
    this.secondHand = this.clock.rect(this.cx, 18, 2, 130, 2).attr({
      fill: "#DCDCDC",
    });

    this.minuteHand = this.clock
      .rect(this.cx, 35, this.handWidth, 115, 3)
      .attr({
        fill: "#35544D",
      });

    this.hourHand = this.clock.rect(this.cx, 80, this.handWidth, 75, 3).attr({
      fill: "#35544D",
    });

    this.clock.circle(this.cx, this.cy, 10).attr({
      fill: "#35544D",
    });
  },

  /**
   * Bind handlers for stop/start btn.
   */
  bindEventHandlers() {
    const self = this;
    $(".stop-btn--clock").on("click", function (event) {
      event.preventDefault();
      const $this = $(this);
      if ($this.hasClass(self.STOPPED_CLASS)) {
        $this.text("Stop");
        self.startClock();
      } else {
        $this.text("Start");
        clearInterval(self.clockInterval);
      }
      $this.toggleClass(self.STOPPED_CLASS);
    });
  },

  /**
   * Update time once per second.
   */
  startClock() {
    this.clockInterval = setInterval(() => {
      this.updateTime();
    }, 1000);
  },

  /**
   * Set some clock sizes which we'll refer to when animating hands.
   */
  setSizes() {
    // set cx/cy for main clock circle (x/y coordinates of center of circle vs. r)
    this.cx = 150;
    this.cy = 150;
    // circle r
    this.r = 140;
    this.handWidth = 6;
    this.adjustCenters = 3; // cx,cy for transforms on min/hour hands get adjusted based on hand widths.
  },

  /**
   * Init module. If we've got a clock wrapper DOM element, draw clock and start it.
   */
  init() {
    if ($(".svg-clock").length) {
      this.setSizes();
      this.drawClock();
      this.updateTime();
      this.bindEventHandlers();
      this.startClock();
    }
  },
};

export default clock;
